import React from 'react'
import { Map } from 'immutable';
import smallTeam from '../../../assets/img/small-team-icon.svg';
import { useSelector } from 'react-redux';

const defaultDistribution = Map({
  "focused": {
    "A": 0, "V": 0, "K": 0
  },
  "sorting": {
    "A": 0, "V": 0, "K": 0
  },
  "open": {
    "A": 0, "V": 0, "K": 0
  }
});

export const MindPatternsTeamDistribution = ({ distribution, teamMP, areas }) => {
  const patternOrder = teamMP ? teamMP.split('') : ['A', 'V', 'K'];
  const currentDistribution = distribution?.size ? distribution : defaultDistribution;
  const teamStats = useSelector((state) => state.team_resume_stats);

  const getArea = (mp) => {
    const area = areas?.items?.find((item) => item.code === mp);
    return area;
  }

  return (
    <div className='rounded border p-3 mb-3 mb-lg-0'>
      <div className='pr-xl-5'>
      <h4 className='h5'>Team's overall distribution</h4>
      <p>Distribution of each type of attention ('auditory', 'vistual' or 'kinesthetic') across the 3 states of attention ('focused', 'sorting' or 'open')</p>
      </div>

      <div className='pt-4 text-center'>
        
        <div className='px-4'>
        <table className='table table-borderless mb-0'>
          <thead>
            <tr>
              <th scope="col" className='p-1'></th>
              {patternOrder.map((letter, index) => {
                const area = getArea(letter);

                if (!area) return null;

                return (
                  <th scope="col" key={index} width='25%' className='p-1'>
                    <div className='text-center px-2'>
                      <img src={area.icon} alt={area.name} width={32} height='auto' className='mx-auto' />
                      <p className='font-weight-normal mb-0'>{area.name}</p>
                    </div>
                  </th>
                )
              })}
            </tr>
          </thead>
          {currentDistribution?.size > 0 && 
          <tbody>
            {[...currentDistribution.entries()].map(([sectionKey, item], index) => (
              <tr key={sectionKey}>
                <th scope="row" className='align-middle p-1'>
                  <p className='mb-0 text-wrap h5 font-weight-normal text-right pr-lg-4 pr-2'><span className='text-capitalize'>{sectionKey}</span> attention</p>
                </th>

                {Object.entries(item).map(([key, value]) => (
                  <td key={`${key}-${value}`} className='p-1'>
                    <div className={`text-center rounded border-2 border-${key === 'A' ? 'auditory' : (key === 'V' ? 'visual' : 'kinesthetic')}`}>
                      <p className='mb-0 p-2 p-md-3 font-weight-semibold h5'>{value || 0}%</p>
                    </div>
                  </td>
                ))}
              </tr>
            ))}
            <tr>
              <td></td>
              <td colSpan='3'>
                <div className='py-3'><p className='text-green mb-0 small font-weight-medium'><img src={smallTeam} width={25} height='auto' alt='icon-team' className='mr-2' /> {teamStats.count_mp}/{teamStats.count_members} Completed</p></div>
              </td>
            </tr>
          </tbody>
          }
        </table>
        </div>
        <p className='mb-0 small text-muted'><i>Note that percentages only reflect team members who have completed each assessment.</i></p>
      </div>
    </div>
  )
}
